// Lib
import * as _ from 'lodash';
import { put, call, takeLatest, debounce } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetLMCategoriesAPI, getLMCategoriesAPIError, getLMCategoriesAPISuccess, ActionPostLMCategoriesAPI, postLMCategoriesAPIError, postLMCategoriesAPISuccess } from './actions';
import { LMcategories } from './types';

// Functions
import { parseAPIEngineCategory } from './utils';

// Types
import { ActionGetEngineCategoryAPI, getEngineCategoryAPIError, getEngineCategoryAPISuccess, } from './actions';
import { EngineCategory } from './types';
import { createAPINetworkInstance } from '../../../../../common/api';
import { parseAPILMcategories } from './utils';
import { DEFAULT_PAGE_SIZE } from './constants';

function* getDealerLMcategories(action: ActionGetLMCategoriesAPI) {
    try {
        const { listingId } = action
        const { data } = yield call(createAPINetworkInstance().get, `listing/${listingId}/categories`);
        const lmcategories: LMcategories = parseAPILMcategories(data);
        yield put(getLMCategoriesAPISuccess(lmcategories));
    } catch (err) {
        yield put(getLMCategoriesAPIError());
    }
}

function* postDealerLMCategories(action: ActionPostLMCategoriesAPI) {
    try {
        const { listingId, idengine, iddealer, engineCategories } = action
        const data = {
            "iddealer": iddealer,
            "idengine": idengine,
            "engineCategories": engineCategories
        }
        const response = yield call(createAPINetworkInstance().post, `listing/${listingId}/categories`, data);        
        const lmcategories: LMcategories = parseAPILMcategories(response);
        yield put(postLMCategoriesAPISuccess(response.data.engineCategories));
    } catch (err) {
        yield put(postLMCategoriesAPIError());
    }
}

function* getEngineCategories(action: ActionGetEngineCategoryAPI) {
    try {
        const { idengine, country, language, page, limit, query } = action
        let queryStringParameter = ""
        if (query) {
            queryStringParameter = `&query=${query}`
        }
        const { data } = yield call(createAPINetworkInstance().get, `/engine/${idengine}/categories/${country}/${language}?page=${page ?? 0}&size=${limit ?? DEFAULT_PAGE_SIZE}${queryStringParameter}`);
        const enginecategories: EngineCategory[] = parseAPIEngineCategory(data);        
        yield put(getEngineCategoryAPISuccess(enginecategories, page));
    } catch (err) {
        yield put(getEngineCategoryAPIError(err));
    }
}

export default function* EngineCategorySagas() {
    yield debounce(500, ACTIONS.GET_ENGINECATEGORY_API_REQUEST, getEngineCategories);
    yield takeLatest(ACTIONS.GET_LMCATEGORIES_API_REQUEST, getDealerLMcategories);
    yield takeLatest(ACTIONS.POST_LMCATEGORIES_API_REQUEST, postDealerLMCategories);
}